var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { Country } from 'packages/target/entities/Country';
import { City } from 'packages/target/entities/City';
import { Interest } from 'packages/target/entities/Interest';
import { RegionWithCountry } from 'packages/target/entities/RegionWithCountry';
var TargetingOptions = /** @class */ (function (_super) {
    __extends(TargetingOptions, _super);
    function TargetingOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.countries = [];
        _this.cities = [];
        _this.regions = [];
        _this.interests = [];
        return _this;
    }
    Object.defineProperty(TargetingOptions.prototype, "hasLocationsSet", {
        get: function () {
            return this.countries.length > 0 || this.cities.length > 0 || this.regions.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetingOptions.prototype, "validateOverlap", {
        /**
         * Validates countries and regions to ensure there is no location overlap.
         *
         * Users can select countries, regions, and cities for targeting:
         * - Country: "Estonia"
         * - Region: "Uusimaa"
         * - City: "Turku"
         *
         * However, a user cannot select city within same specified region or country,
         * nor region within specified country per Meta API as following:
         * - Country: "Estonia"
         * - City: "Tallinn"
         * - Region: "Harju"
         *
         * Frontend validation ensures user acknowledges this limitation,
         * without overriding overlapping locations in the backend.
         */
        get: function () {
            var _loop_1 = function (city) {
                var countryOverlap = this_1.countries.find(function (country) { return country.id === city.country.id; });
                if (countryOverlap) {
                    return { value: {
                            isValid: false,
                            message: {
                                key: 'validation.target.overlap.city_country',
                                params: {
                                    city: city.fullName,
                                    country: countryOverlap.name,
                                },
                            },
                        } };
                }
            };
            var this_1 = this;
            // Check countries/cities overlap
            for (var _i = 0, _a = this.cities; _i < _a.length; _i++) {
                var city = _a[_i];
                var state_1 = _loop_1(city);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
            var _loop_2 = function (region) {
                var countryOverlap = this_2.countries.find(function (country) { return country.id === region.country.id; });
                if (countryOverlap) {
                    return { value: {
                            isValid: false,
                            message: {
                                key: 'validation.target.overlap.region_country',
                                params: {
                                    region: region.nameWithCountry,
                                    country: countryOverlap.name,
                                },
                            },
                        } };
                }
            };
            var this_2 = this;
            // Check countries/regions overlap
            for (var _b = 0, _c = this.regions; _b < _c.length; _b++) {
                var region = _c[_b];
                var state_2 = _loop_2(region);
                if (typeof state_2 === "object")
                    return state_2.value;
            }
            var _loop_3 = function (city) {
                var regionOverlap = this_3.regions.find(function (region) { var _a; return parseInt((_a = city.region) === null || _a === void 0 ? void 0 : _a.id) === parseInt(region.id); });
                if (regionOverlap) {
                    return { value: {
                            isValid: false,
                            message: {
                                key: 'validation.target.overlap.city_region',
                                params: {
                                    city: city.fullName,
                                    region: regionOverlap.nameWithCountry,
                                },
                            },
                        } };
                }
            };
            var this_3 = this;
            // Check cities/regions overlap
            for (var _d = 0, _e = this.cities; _d < _e.length; _d++) {
                var city = _e[_d];
                var state_3 = _loop_3(city);
                if (typeof state_3 === "object")
                    return state_3.value;
            }
            return { isValid: true };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Type(Country),
        __metadata("design:type", Array)
    ], TargetingOptions.prototype, "countries", void 0);
    __decorate([
        Type(City),
        __metadata("design:type", Array)
    ], TargetingOptions.prototype, "cities", void 0);
    __decorate([
        Type(RegionWithCountry),
        __metadata("design:type", Array)
    ], TargetingOptions.prototype, "regions", void 0);
    __decorate([
        Type(Interest),
        __metadata("design:type", Array)
    ], TargetingOptions.prototype, "interests", void 0);
    return TargetingOptions;
}(Entity));
export { TargetingOptions };
